module.exports = __webpack_public_path__ + "img/8_75.fe313e29.png";